import { useStore } from "../../state/useStore.ts";
import "./ProgressHud.css";
import { K } from "../../state/keys.ts";
import { hudView } from "../../domain/hudView.ts";
import type { Progress } from "../../domain/progressRules.ts";
import { t } from "../../i18n/common.ts";

/** Belt, streak and XP in the header, and the way in to the progress page. */
export function ProgressHud() {
    const summary = useStore(K.progress.summary) as Progress | null;
    if (!summary) return null;

    const view = hudView(summary);
    return (
        <a class="progress-hud" href="/progress" title={t("yourProgress")} style={`--belt-color: ${view.beltColor}`}>
            {view.streak && (
                <span class="progress-hud__streak" title={t("daysInARow")} data-active={String(view.streakActive)}>
                    {view.streak}
                </span>
            )}
            <span class="progress-hud__belt">
                <span class="progress-hud__belt-name">{view.beltName}</span>
                <span class="progress-hud__bar">
                    <span class="progress-hud__bar-fill" style={`width: ${view.beltPct}%`} />
                </span>
            </span>
            <span class="progress-hud__today" title={view.todayTitle} data-done={String(view.todayDone)}>
                {view.todayDots}
            </span>
            <span class="progress-hud__xp">{view.xp}</span>
        </a>
    );
}
